export default __webpack_public_path__ + "static/media/warning--slippery-road-surface--g2.cc75b2dd.png";